import React from "react";
import { Tabs, Typography } from "antd";
import AppLayout from "../components/layout/AppLayout";
import CustomerTransactionForm from "../components/transactions/CustomerTransactionForm";
import CustomerTransactionExcelImport from "../components/transactions/CustomerTransactionExcelImport";

const { Title } = Typography;

export default function CreateTransactionRequestPage() {
    return (
        <AppLayout>
            <Title level={2}>New Request</Title>

            <Tabs
                defaultActiveKey="single"
                items={[
                    {
                        key: "single",
                        label: "Single Request",
                        children: <CustomerTransactionForm />,
                    },
                    {
                        key: "excel",
                        label: "Excel Import",
                        children: <CustomerTransactionExcelImport />,
                    },
                ]}
            />
        </AppLayout>
    );
}